// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1oemL","selects":"Documents_selects__1msSb"};